import styled from "styled-components";

export const EP_Container = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	padding: 54px 0 80px;
`;

export const EP_Card = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	max-width: 560px;
	padding: 42px 34px;
	border: 1px solid rgba(216, 159, 91, 0.28);
	border-radius: 18px;
	background: linear-gradient(180deg, #fffdf8 0%, #ffffff 100%);
	text-align: center;
	box-shadow: 0 16px 40px rgba(32, 24, 16, 0.06);
`;

export const EP_Icon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 108px;
	height: 108px;
	margin-bottom: 24px;
	border-radius: 50%;
	background: rgba(216, 159, 91, 0.12);
	color: #d89f5b;
`;

export const EP_Title = styled.h2`
	margin: 0;
	font-size: 28px;
	font-weight: 700;
	line-height: 34px;
	color: #191919;
`;

export const EP_Description = styled.p`
	max-width: 460px;
	margin: 14px 0 24px;
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
	color: #6c625c;
`;

export const EP_Items = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 10px;
`;

export const EP_Item = styled.div`
	display: inline-flex;
	align-items: center;
	column-gap: 8px;
	padding: 9px 13px;
	border-radius: 999px;
	background: rgba(216, 159, 91, 0.08);
	color: #9e7847;
	font-size: 14px;
	font-weight: 600;
`;
